import { render, staticRenderFns } from "./csr_queue.vue?vue&type=template&id=153ec54e&scoped=true&"
import script from "./csr_queue.vue?vue&type=script&lang=js&"
export * from "./csr_queue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153ec54e",
  null
  
)

export default component.exports